module.exports = __webpack_public_path__ + "img/promo-bg.142dba8.jpg";